import { render, staticRenderFns } from "./ProbnoPitanjeSingle.vue?vue&type=template&id=deea0a92&scoped=true&"
import script from "./ProbnoPitanjeSingle.vue?vue&type=script&lang=js&"
export * from "./ProbnoPitanjeSingle.vue?vue&type=script&lang=js&"
import style0 from "./ProbnoPitanjeSingle.vue?vue&type=style&index=0&id=deea0a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deea0a92",
  null
  
)

export default component.exports